module.exports = __webpack_public_path__ + "9f5ec4c094ffe2c62cf8c01a22eef0dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/duke_university_2021_chart.png
// module id = 1670
// module chunks = 0